import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEudrUploadedFilesRequestPayload } from 'redux/reducers/eudr/types';
import { TEudrApi } from './types';

export const eudr: TEudrApi = {
	getStatus: () => http.get(endpoint.eudr.GET_STATUS).then((response) => response.data),
	getPlans: () => http.get(endpoint.eudr.GET_PLANS).then((response) => response.data),
	getInformation: () => http.get(endpoint.eudr.GET_INFORMATION).then((response) => response.data),
	uploadFile: (data: FormData) =>
		http.post(endpoint.eudr.UPLOAD_FILE, data).then((response) => response.data),
	downloadFile: (id: number) =>
		http
			.post(endpoint.eudr.DOWNLOAD_FILE(id), null, { responseType: 'blob' })
			.then((response) => response.data),
	getUploadedFiles: (payload: TEudrUploadedFilesRequestPayload) =>
		http.post(endpoint.eudr.UPLOADED_FILES, payload).then((response) => response.data),
};
